import { apiClient } from '@shared/utils/api-client';
import type { BonusUser, ManualBonusAdjustDto } from '../types';

export const bonusesApi = {
  getUsers: async (phone?: string): Promise<BonusUser[]> => {
    const params = phone ? `?phone=${encodeURIComponent(phone)}` : '';
    return apiClient.get<BonusUser[]>(`/bonuses/users${params}`);
  },

  manualAdjust: async (data: ManualBonusAdjustDto) => {
    return apiClient.post('/bonuses/adjust', data);
  },
};
